import { FaRegFilePdf } from "react-icons/fa6";
import { formatDate, getUploadUrl, getImageUrl } from "src/Common/common";
import { isAccountant, isClericalOver } from "src/Common/function";

const AttachmentCard = ({ attachment, onPreview, onEdit, onDelete, onDownload }) => {
  return (
    <div className="w-full max-w-[280px] border-[1px] border-borderColor rounded-[14px] p-3 bg-white">
      <button
        type="button"
        className="w-full h-[200px] rounded-[6px] overflow-hidden bg-[#f2f4f7] flex items-center justify-center border-[2px] border-borderColor cursor-pointer"
        onClick={onPreview}
      >
        {attachment.isPdf ? (
          <div className="flex flex-col items-center justify-center text-subTitleColor gap-2">
            <FaRegFilePdf size={42} />
            <span className="font-OpenSansRegular text-[12px] font-[600]">PDF</span>
          </div>
        ) : (
          <img
            src={getUploadUrl(attachment.fileName)}
            alt={attachment.displayName}
            className="w-full h-full object-cover"
          />
        )}
      </button>

      <div className="w-full mt-3 min-w-0 grid grid-cols-[minmax(0,1fr)_auto] items-start gap-2">
        <span
          className={`min-w-0 max-w-full overflow-hidden whitespace-pre-wrap break-words font-OpenSansRegular text-[13px] leading-[18px] ${attachment.description ? "text-titleColor" : ""
            }`}
          style={!attachment.description ? { color: "#80869E" } : undefined}
        >
          {attachment.description || "No Description"}
        </span>
        {(isClericalOver() || isAccountant()) &&
          <div className="flex shrink-0 items-center gap-1 pt-[2px] text-subTitleColor self-start">
            <img
              src={getImageUrl("/images/common/download_black.png")}
              className="w-[14px] cursor-pointer"
              onClick={onDownload}
            />
            <img
              src={getImageUrl("/images/common/edit.png")}
              className="w-[14px] cursor-pointer"
              onClick={onEdit}
            />
            <img
              src={getImageUrl("/images/common/black_trash.png")}
              className="w-[15px] cursor-pointer"
              onClick={onDelete}
            />
          </div>
        }
      </div>

      <div className="mt-2 flex items-center gap-2 flex-wrap min-h-[20px]">
        {attachment.tags?.length ? (
          attachment.tags.map((tag) => (
            <span
              key={`${attachment.id}-${tag?.id || tag?.name}`}
              className="font-OpenSansRegular text-[11px] text-subTitleColor bg-[#E9EDF3] rounded-[999px] px-2 py-[2px] h-[20px]"
            >
              {tag?.name}
            </span>
          ))
        ) : (
          <span className="font-OpenSansRegular text-[13px] text-[#80869E]">No tag</span>
        )}
      </div>

      <div className="mt-4">
        <p className="font-OpenSansRegular text-[12px] text-titleColor">{attachment.createdBy}</p>
        <p className="font-OpenSansRegular text-[12px] text-titleColor">
          {attachment.createdAt ? formatDate(attachment.createdAt) : "-"}
        </p>
      </div>
    </div>
  );
};

export default AttachmentCard;
